import { z } from "zod"

export const tfrGeoserverPropertiesSchema = z
    .object({
        GID: z.union([z.string(), z.number()]).optional(),
        CNS_LOCATION_ID: z.string().nullable().optional(),
        NOTAM_KEY: z.string(),
        TITLE: z.string().nullable().optional(),
        LAST_MODIFICATION_DATETIME: z.string().nullable().optional(),
        STATE: z.string().nullable().optional(),
        LEGAL: z.string().nullable().optional(),
    })
    .loose()

export const tfrGeoserverFeatureSchema = z
    .object({
        type: z.literal("Feature"),
        geometry: z.object({ type: z.string() }).loose().nullable(),
        properties: tfrGeoserverPropertiesSchema,
    })
    .loose()

export const tfrGeoserverResponseSchema = z
    .object({
        type: z.string(),
        features: z.array(tfrGeoserverFeatureSchema),
    })
    .loose()

export type TfrGeoserverProperties = z.infer<typeof tfrGeoserverPropertiesSchema>
export type TfrGeoserverFeature = z.infer<typeof tfrGeoserverFeatureSchema>
export type TfrGeoserverResponse = z.infer<typeof tfrGeoserverResponseSchema>
